import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Select from 'react-select';


class RestaurantListView extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.state = {
      current: null,
    };
  }

  componentDidMount() {
    this.setState({
      current: this.props.selected ? this.props.selected.id : null,
    });
  }

  handleChange(selection) {
    this.setState({
      current: selection.value,
    });
    this.props.onChange(selection.value);
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let result = {};
    if (!!nextProps.selected) {
      result.current = nextProps.selected.id;
    }
    return result;
  }

  render() {
    const {list, classes} = this.props;
    let restaurantList = [];
    if (list.size > 0) {
      list.toArray().forEach(obj => {
        if (!obj.now_is_closed && !obj.now_is_unavailable) {
          restaurantList.push({
            value: obj.id,
            label: obj.name,
          });
        }
      });
    }
    return (
      <Select
        name="form-restaurants"
        clearable={false}
        value={this.state.current}
        className={classes}
        options={restaurantList}
        onChange={this.handleChange}
        searchable={false}
      />
    );
  }
}

RestaurantListView.propTypes = {
  list: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selected: PropTypes.object,
  classes: PropTypes.string,
  onChange: PropTypes.func,
};

export default RestaurantListView;


// WEBPACK FOOTER //
// ./src/components/Restaurant/RestaurantListView.js